// src/data/content.js
// ─── Single source of truth for ALL UI text ──────────────────────────────────

export const NAVBAR = {
  ar: {
  home: 'الرئيسية', about: 'لماذا نحن', services: 'الخدمات',
  portfolio: 'القطاعات', faq: 'أسئلة', contact: 'تواصل معنا',
  jobs: 'وظائف',
  langLabel: 'EN',
},
en: {
  home: 'Home', about: 'Why Us', services: 'Services',
  portfolio: 'Sectors', faq: 'FAQ', contact: 'Contact',
  jobs: 'Careers',
  langLabel: 'عربي',
},

};

export const FOOTER = {
  ar: {
    about:
      'لواصق للصناعات: ريادة تمتد لأكثر من 25 عاماً في حلول الطباعة والتغليف. نلتزم بأعلى معايير الجودة العالمية لخدمة كبرى الشركات في مصر والشرق الأوسط.',
    quickLinks: 'روابط سريعة',
    links: {
      home: 'الرئيسية', about: 'لماذا نحن',
      services: 'خدماتنا', portfolio: 'القطاعات', contact: 'تواصل معنا',
    },
    contactUs : 'معلومات التواصل',
    address   : 'المنطقة الصناعية، مدينة العبور، مصر',
    copyright : 'جميع الحقوق محفوظة © 2026',
  },
  en: {
    about:
      'Lawaseq Industries: Over 25 years of leadership in printing and packaging solutions, committed to international quality standards.',
    quickLinks: 'Quick Links',
    links: {
      home: 'Home', about: 'Why Us',
      services: 'Services', portfolio: 'Sectors', contact: 'Contact',
    },
    contactUs : 'Contact Info',
    address   : 'Industrial Zone, Al-Obour City, Egypt',
    copyright : 'All Rights Reserved © 2026',
  },
};

export const HERO = {
  ar: {
    title    : 'لواصق للطباعة والتغليف | الشريك الصناعي الأول لكبرى الشركات',
    subtitle : 'نضع بين يديك خبرة سنوات في حلول التغليف المتطورة، بقدرة إنتاجية تتجاوز 100 مليون ملصق شهرياً وبأعلى معايير الجودة العالمية.',
    cta1: 'المبيعات',
    cta2: 'حلولنا',
    stats: [
      { end: 150, suffix: '+', desc: 'شريك'  },
      { end: 100, suffix: 'M', desc: 'ملصق / شهرياً' },
      { end: 25,  suffix: '',  desc: 'خبرة'  },
    ],
  },
  en: {
    title    : 'Lawaseq for Printing & Packaging | The Premier Industrial Partner',
    subtitle : 'Bringing decades of expertise in advanced packaging solutions, with production capacity exceeding 100 million labels per month, held to the highest international quality standards.',
    cta1: 'Sales',
    cta2: 'Solutions',
    stats: [
      { end: 150, suffix: '+', desc: 'Partners'       },
      { end: 100, suffix: 'M', desc: 'Labels / Month' },
      { end: 25,  suffix: '+', desc: 'Years Exp.'     },
    ],
  },
};

export const WHY_LAWASEQ = {
  ar: {
    title    : 'لماذا نحن الخيار الأول؟',
    subtitle : 'نجمع بين التكنولوجيا المتطورة والخبرة العميقة لنقدم حلولاً تتجاوز التوقعات',
    swipeText: 'اسحب للمزيد',
    features : [
      { title: 'قدرة إنتاجية ضخمة',  desc: 'خطوط فليكسو متطورة تدعم حتى 9 ألوان بطاقة تتجاوز 100 مليون ملصق شهرياً.', number: '100M+' },
      { title: 'معايير جودة دولية',  desc: 'حاصلون على ISO 9001:2015 مع الالتزام التام بنظم الرقابة الداخلية.', number: 'ISO' },
      { title: 'دقة ثبات الألوان',    desc: 'نظام Pantone المعتمد يضمن مطابقة هوية علامتك التجارية بدقة 100%.', number: '100%' },
      { title: 'خبرة صناعية عريقة', desc: 'أكثر من 25 عاماً من الريادة في تلبية متطلبات كبرى الشركات العالمية.', number: '25+' },
    ],
  },
  en: {
    title    : "Why We're the First Choice?",
    subtitle : 'Combining Technology with Expertise for Exceptional Industrial Solutions',
    swipeText: 'Swipe to explore',
    features : [
      { title: 'Production Scale',   desc: 'Advanced 9-color Flexo lines with capacity exceeding 100 million labels monthly.', number: '100M+' },
      { title: 'Global Quality',     desc: 'ISO 9001:2015 certified with strict internal quality control systems.', number: 'ISO' },
      { title: 'Color Precision',    desc: 'Certified Pantone System ensures 100% brand identity matching.', number: '100%' },
      { title: 'Industrial Legacy',  desc: 'Over 25 years of excellence meeting global market leader requirements.', number: '25+' },
    ],
  },
};

export const SERVICES = {
  ar: {
    title    : 'حلول إنتاج متكاملة',
    subtitle : 'نستخدم أحدث تكنولوجيا طباعة الملصقات في العالم',
    swipeText: 'اسحب لرؤية المزيد',
    services : [
      { title: 'طباعة فليكسو (Flexo)', desc: 'طباعة رول ملصقات حتى 9 ألوان بدقة فائقة. نضمن ثبات الألوان لكبرى الشركات.', features: ['9 ألوان UV', 'إنتاج رول ضخم'] },
      { title: 'تشطيبات فاخرة',         desc: 'لمسات فنية بتقنيات الـ Hot Stamping والـ Embossing لتمييز عبوات مستحضرات التجميل.', features: ['تذهيب حراري', 'نقش بارز'] },
      { title: 'قص وتشكيل صناعي',      desc: 'عمليات القص (Die-Cutting) لضمان توافق الملصقات مع خطوط التعبئة الآلية السريعة.', features: ['دقة ميكرونية', 'تجهيز آلي'] },
    ],
  },
  en: {
    title    : 'Production Solutions',
    subtitle : 'State-of-the-Art Label Printing Technology',
    swipeText: 'Swipe to explore',
    services : [
      { title: 'High-End Flexo',          desc: 'Up to 9-color UV Flexo printing for high-volume roll labels with absolute consistency.', features: ['9 Color UV', 'High Capacity'] },
      { title: 'Premium Finishing',        desc: 'Hot Foil Stamping & Embossing to elevate brand packaging for premium products.', features: ['Hot Foil', 'Embossing'] },
      { title: 'Industrial Die-Cutting',   desc: 'Precision Die-Cutting engineered perfectly for high-speed automatic labeling lines.', features: ['Micron Accuracy', 'Line Ready'] },
    ],
  },
};

export const INDUSTRIES = {
  ar: {
    title       : 'خبرة في قطاعات حيوية',
    subtitle    : 'سجل حافل بـ 2000+ مشروع في 6 قطاعات رئيسية',
    swipeHint   : 'اسحب لاستكشاف القطاعات',
    projectLabel: 'مشروع',
    industries  : [
      { name: 'الأغذية',   desc: 'خامات آمنة تماماً ومعتمدة للاستخدام الغذائي', projects: '650' },
      { name: 'الأدوية',   desc: 'ملصقات طبية دقيقة متوافقة مع معايير GMP',       projects: '450' },
      { name: 'المنظفات', desc: 'مقاومة كيميائية عالية للأحبار والخامات',         projects: '350' },
      { name: 'التجميل',  desc: 'تشطيبات فاخرة تليق بالعلامات الراقية',          projects: '250' },
      { name: 'الدهانات', desc: 'حلول متخصصة للعبوات الصناعية الضخمة',            projects: '180' },
      { name: 'الزيوت',   desc: 'ملصقات مقاومة للحرارة والزيوت القوية',           projects: '120' },
    ],
  },
  en: {
    title       : 'Industrial Expertise',
    subtitle    : 'Proven track record across 6 major sectors',
    swipeHint   : 'Swipe to explore sectors',
    projectLabel: 'Projects',
    industries  : [
      { name: 'Food',       desc: 'FDA approved safe materials',               projects: '650' },
      { name: 'Pharma',     desc: 'Precision labels complying with GMP',       projects: '450' },
      { name: 'Detergents', desc: 'High chemical resistance inks',             projects: '350' },
      { name: 'Cosmetics',  desc: 'Luxury finishes for premium brands',        projects: '250' },
      { name: 'Paints',     desc: 'Specialized industrial solutions',          projects: '180' },
      { name: 'Oils',       desc: 'Heat and oil resistant solutions',          projects: '120' },
    ],
  },
};

export const PORTFOLIO = {
  ar: {
    title       : 'حلولنا المتخصصة حسب القطاع',
    subtitle    : 'نقدم أعلى معايير الجودة العالمية المصممة خصيصاً لتلبية احتياجات كبرى العلامات التجارية',
    btnText     : 'طلب عينة / استشارة فنية',
    detailsLabel: 'تفاصيل',
    categories  : { all: 'الكل', pharma: 'الأدوية', cosmetics: 'التجميل', food: 'الأغذية', automotive: 'الزيوت', detergents: 'المنظفات' },
  },
  en: {
    title       : 'Industry Solutions',
    subtitle    : 'Global printing standards tailored for major brands',
    btnText     : 'Request Sample',
    detailsLabel: 'Details',
    categories  : { all: 'All', pharma: 'Pharma', cosmetics: 'Cosmetics', food: 'Food', automotive: 'Oils', detergents: 'Detergents' },
  },
};

// Projects are static — language-aware labels resolved at runtime in the component
export const PROJECTS = [
  {
    category: ['food'],
    image    : '/assets/images/Food & Beverage Packaging.webp',
    title    : { ar: 'ملصقات الأغذية والمشروبات', en: 'Food & Beverage Labels' },
    desc     : { ar: 'خامات معتمدة مقاومة للرطوبة والتجميد لضمان سلامة المنتج.', en: 'FDA-approved materials resistant to moisture and freezing.' },
  },
  {
    category: ['cosmetics', 'pharma', 'automotive'],
    image    : '/assets/images/multi-layer-printed-label.webp',
    title    : { ar: 'ملصقات البيانات المكثفة', en: 'Multi-layer Labels' },
    desc     : { ar: 'حلول ذكية لطباعة كميات بيانات هائلة في مساحات محدودة.', en: 'Smart solutions for printing extensive data in limited spaces.' },
  },
  {
    category: ['pharma'],
    image    : '/assets/images/pharma.webp',
    title    : { ar: 'قطاع الأدوية والطب', en: 'Pharmaceutical Labels' },
    desc     : { ar: 'طباعة عالية الدقة مع ضمان سهولة التتبع والتحقق.', en: 'High-precision printing with traceability and security features.' },
  },
  {
    category: ['cosmetics'],
    image    : '/assets/images/tube-packaging-premium.webp',
    title    : { ar: 'طباعة العبوات الأنبوبية', en: 'Tube Printing' },
    desc     : { ar: 'تكنولوجيا الطباعة المباشرة على الأنابيب لمظهر فاخر وجودة تدوم.', en: 'Direct-to-tube printing for a premium appearance and durability.' },
  },
  {
    category: ['automotive'],
    image    : '/assets/images/Automotive Oils Packaging.webp',
    title    : { ar: 'زيوت المحركات والسيارات', en: 'Automotive & Oils Labels' },
    desc     : { ar: 'ملصقات شديدة التحمل مقاومة للزيوت، الحرارة والظروف القاسية.', en: 'Heavy-duty labels resistant to oils, heat, and harsh environments.' },
  },
  {
    category: ['detergents'],
    image    : '/assets/images/Cleaning Products Labels.webp',
    title    : { ar: 'المنظفات والمنتجات المنزلية', en: 'Cleaning Products Labels' },
    desc     : { ar: 'ملصقات مقاومة للمواد الكيميائية والسوائل مع ثبات ألوان فائق.', en: 'Chemical-resistant labels with superior color stability.' },
  },
  {
    category: ['cosmetics'],
    image    : '/assets/images/Beauty Products Labels.webp',
    title    : { ar: 'منتجات التجميل والعناية', en: 'Beauty Products Labels' },
    desc     : { ar: 'تصاميم راقية تعكس فخامة علامتك التجارية وتجذب المستهلك.', en: 'Elegant designs reflecting your brand luxury and attracting consumers.' },
  },
];

export const TESTIMONIALS = {
  ar: {
    title   : 'شركاء النجاح',
    subtitle: 'ثقة صناعية تمتد عبر القارات',
    items   : [
      { name: 'مدير قطاع التصنيع', company: 'شركة أدوية عالمية (Multinational)', text: 'الالتزام بمعايير GMP والقدرة الإنتاجية العالية جعلت من لواصق شريكاً استراتيجياً لا غنى عنه في خطوط إنتاجنا الدوائية.', rating: 5 },
      { name: 'مدير الجودة',         company: 'علامة تجارية فاخرة للتجميل',          text: 'دقة الألوان وثبات الجودة عبر ملايين الوحدات المنتجة هو ما يميز لواصق. إنهم يتفهمون جيداً متطلبات التعبئة الفاخرة.', rating: 5 },
      { name: 'رئيس المشتريات',      company: 'مجموعة غذائية كبرى',                  text: 'سرعة الاستجابة في المواسم والالتزام الصارم بجداول التوريد منحنا استقراراً كبيراً. موثوقية نادرة في السوق.', rating: 5 },
    ],
  },
  en: {
    title   : 'Success Partners',
    subtitle: 'Industrial Trust Across Continents',
    items   : [
      { name: 'Manufacturing Director', company: 'Global Pharma Multinational', text: 'Full GMP compliance and high capacity have made Lawaseq an indispensable strategic partner for our production lines.', rating: 5 },
      { name: 'QA Manager',             company: 'Premium Cosmetics Brand',     text: 'Color precision and consistent quality across millions of units set Lawaseq apart. They truly understand premium packaging needs.', rating: 5 },
      { name: 'Head of Procurement',    company: 'Leading Food Group',          text: 'Fast response during peak seasons and strict adherence to schedules gave us great stability. Rare reliability in the market.', rating: 5 },
    ],
  },
};

export const FAQ_CONTENT = {
  ar: {
    title    : 'الأسئلة التقنية والشائعة',
    subtitle : 'إجابات متخصصة حول معايير الجودة والقدرات الإنتاجية لمصنع لواصق',
    questions: [
      { q: 'ما هي قدرات الطباعة المتوفرة وتعدد الألوان؟',             a: 'نعتمد على تكنولوجيا الفليكسو (Flexo) المتطورة التي تدعم الطباعة حتى 9 ألوان بدقة فائقة، مع إمكانية إضافة اللامنيشن، الكولد فويل، والطباعة على ظهر الملصق (Back printing) في خط إنتاج واحد.' },
      { q: 'ما هي أنواع الخامات والتشطيبات التي يوفرها المصنع؟',      a: 'نطبع على كافة الخامات العالمية مثل الورق، والبلاستيك (BOPP) الشفاف واللامع، والخامات المعدنية. كما نوفر لمسات نهائية متنوعة تشمل الورنيش (UV)، اللامنيشن، والطباعة الحرارية.' },
      { q: 'كيف تضمن لواصق جودة الإنتاج ومطابقة الألوان؟',           a: 'نحن حاصلون على شهادة ISO 9001:2015 ونستخدم نظام Pantone العالمي لمطابقة الألوان. لدينا نظام رقابة داخلي صارم يضمن ثبات جودة الألوان ومنع أخطاء الخلط (Zero Mix-up).' },
      { q: 'ما هي المدة المستغرقة للتسليم وكيفية توريد المنتج؟',      a: 'يتم التسليم خلال 7 إلى 10 أيام عمل من اعتماد التصميم. ونورد الملصقات في شكل رول (Rolls) مجهز لماكينات التعبئة الآلية، مع إمكانية التوريد في شكل شيت (Sheets) حسب الطلب.' },
    ],
  },
  en: {
    title    : 'Technical FAQ',
    subtitle : "Professional insights into LAWASEQ's production standards and quality control",
    questions: [
      { q: 'What are your printing capabilities and color range?',        a: 'We utilize advanced Flexo presses supporting up to 9 colors in a single pass, integrated with lamination, cold foil, and back-side printing capabilities.' },
      { q: 'What materials and finishing options do you offer?',          a: 'We print on various substrates including Paper, Clear & White BOPP (Plastic), and Metallized films. Finishing options include UV Varnish, Lamination, and Hot/Cold Foil.' },
      { q: 'How do you ensure production quality and color consistency?', a: 'We are ISO 9001:2015 certified and use the Pantone Matching System (PMS). Our internal QC ensures color stability and zero mix-up errors across all production batches.' },
      { q: 'What is the delivery turnaround and supply format?',          a: 'Standard delivery is 7-10 working days after artwork approval. We supply labels in Rolls optimized for automatic labeling machines, or in Sheets upon request.' },
    ],
  },
};

export const CONTACT = {
  ar: {
    title       : 'تواصل معنا',
    subtitle    : 'نحن هنا للإجابة على استفساراتكم الفنية وتلبية طلباتكم الصناعية',
    address     : 'LAWASEQ Egypt | شارع ١٦، العبور، محافظة القليوبية',
    workingHours: 'الأحد - الخميس: 8:00 ص - 5:00 م',
    labels      : { location: 'الموقع', phone: 'الهاتف', email: 'البريد الإلكتروني', hours: 'مواعيد العمل', whatsapp: 'واتساب المبيعات' },
  },
  en: {
    title       : 'Get in Touch',
    subtitle    : 'Contact our technical team for inquiries and industrial orders',
    address     : 'LAWASEQ Egypt | 16th Street, Al-Obour City, Qalyubia',
    workingHours: 'Sun – Thu: 8:00 AM – 5:00 PM',
    labels      : { location: 'Location', phone: 'Phone', email: 'Email', hours: 'Working Hours', whatsapp: 'Sales WhatsApp' },
  },
};

export const WHATSAPP = {
  ar: {
    message       : 'أهلاً بك في لواصق! كيف يمكننا مساعدتك اليوم؟',
    status        : 'متصل الآن',
    supportName   : 'دعم لواصق',
    presetMessages: ['طلب عرض سعر لمشروع جديد', 'الاستفسار عن خامات الطباعة', 'طلب عينة من الملصقات'],
  },
  en: {
    message       : 'Welcome to Lawaseq! How can we help you today?',
    status        : 'Online Now',
    supportName   : 'Lawaseq Support',
    presetMessages: ['Request a quote for a project', 'Inquire about printing materials', 'Request product samples'],
  },
};

export const JOBS = {
  ar: {
    title   : 'انضم لفريقنا',
    subtitle: 'الوظائف المتاحة حالياً — قدّم الآن وانضم لعائلة لواصق',
    btnText : 'قدّم الآن',
    depts   : [
      {
        name: 'الإدارة المالية',
        jobs: ['مدير مالي', 'محاسب', 'أمين مخازن'],
      },
      {
        name: 'إدارة المبيعات',
        jobs: ['مدير مبيعات', 'مندوب مبيعات', 'Sales Support'],
      },
      {
        name: 'إدارة الإنتاج',
        jobs: ['مدير إنتاج', 'مهندس إنتاج', 'فني طباعة', 'مساعد طباعة', 'فني تقطيع', 'مساعد تقطيع', 'Graphic Designer'],
      },
      {
        name: 'إدارة الجودة',
        jobs: ['مدير جودة', 'مشرف جودة'],
      },
    ],
  },
  en: {
    title   : 'Join Our Team',
    subtitle: 'Current openings — Apply now and join the Lawaseq family',
    btnText : 'Apply Now',
    depts   : [
      {
        name: 'Finance',
        jobs: ['Finance Manager', 'Accountant', 'Warehouse Keeper'],
      },
      {
        name: 'Sales',
        jobs: ['Sales Manager', 'Sales Representative', 'Sales Support'],
      },
      {
        name: 'Production',
        jobs: ['Production Manager', 'Production Engineer', 'Print Technician', 'Print Assistant', 'Cutting Technician', 'Cutting Assistant', 'Graphic Designer'],
      },
      {
        name: 'Quality',
        jobs: ['Quality Manager', 'Quality Supervisor'],
      },
    ],
  },
};
